export const columns = [
  {
    title: "合同编号",
    width: 200,
    key: "contractBizNo",
    fixed: "left",
  },
  {
    title: "合同名称",
    width: 300,
    dataIndex: "contractName",
    key: "contractName",
  },
  {
    title: "合同类型",
    width: 300,
    dataIndex: "type",
    key: "type",
    slots: { customRender: "type" },
  },
];

export const columns2 = [
  {
    title: "合同名称",
    width: 220,
    key: "contractName",
  },
  {
    title: "合同编号",
    width: 130,
    key: "bizNo",
  },
];
